import styles from './add-import-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { FormEvent, useContext, useState } from 'react';
import { getPlainDate } from '../../helpers';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SecondaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { ISupportTicket } from '../../_models/support-ticket';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface AddImportDialogProps {
  open: boolean,
  onClose: () => void,
  contractId: string
}

export function AddImportDialog(props: AddImportDialogProps) {
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const makeRequest = useMakeRequestHook();
  const { t } = useTranslation();
  const [ticket, setTicket] = useState<ISupportTicket | undefined>(undefined);
  const [ticketId, setTicketId] = useState<string>('');

  const handleTicketIdChange = (event: FormEvent<HTMLInputElement>) => {
    setTicket(draft => undefined);
    setTicketId(event.currentTarget.value);
  };

  const handleTicketClick = () => {
    makeRequest(`tickets/${ticketId}`).then(ticket => {
      setTicket(ticket);
    });
  };

  const handleImportClick = () => {
    ticket && makeRequest(`tickets/${ticketId}/action/importToContract/${props.contractId}`, 'PUT').then((result) => {
      setSnackbarMessage({ content: t('standard.changesFocusAccount'), type: "success" });
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('standard.couldNotChangeFocusAccount'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.importTicket')}
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-row align-items-end flex-wrap mb-3">
          <div className="me-2">
            <TextField
              value={ticketId}
              onChange={handleTicketIdChange}
              label={t('addImport.ticketID')}
              sx={{ width: '206px' }}
            />
          </div>
          <SecondaryButton
            variant="outlined"
            size='large'
            onClick={handleTicketClick}
            component='div'>
            {t('standard.getTicket')}
          </SecondaryButton>
        </div>
        <div className='mb-3'>
          <TextField
            value={ticket?.title}
            fullWidth
            label={t('standard.title')}
            disabled
          />
        </div>
        <Row>
          <Col md={5}>
            <div className='mb-3'>
              <TextField
                value={getPlainDate(ticket?.date, t)}
                fullWidth
                label={t('standard.date')}
                disabled
              />
            </div>
          </Col>
        </Row>
        <div className='mb-3'>
          <TextField
            value={ticket?.person}
            fullWidth
            label="Person"
            disabled
          />
        </div>
        <Row>
          <Col md={5}>
            <div className='mb-3'>
              <TextField
                value={ticket?.company}
                fullWidth
                label={t('standard.companyNumber')}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <div className='mb-3'>
              <TextField
                value={ticket?.contract}
                fullWidth
                label={t('standard.contractNo')}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <div className='mb-3'>
              <TextField
                value={ticket?.usedTime}
                fullWidth
                label={t('addImport.usedTime')}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <div className='mb-3'>
              <TextField
                value={ticket?.message}
                fullWidth
                label={t('addImport.numberOfMessages')}
                disabled
              />
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleImportClick}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default AddImportDialog;